import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeInstaller, isEmployeeInstaller, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'isEmployeeInstaller' })
export class IsEmployeeInstallerPipe implements PipeTransform {
  transform(user: User | EmployeeInstaller): user is EmployeeInstaller {
    return isEmployeeInstaller(user);
  }
}
